<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 20 18">
    <g clip-path="url(#clip0_6892_8933)">
      <path
        d="M16.4249 1.125V0H13.0719V1.125H7.48371V0H4.13077V1.125H0.777832V18H19.7778V1.125H16.4249ZM14.1896 1.125H15.3072V3.375H14.1896V1.125ZM5.24842 1.125H6.36607V3.375H5.24842V1.125ZM18.6602 16.875H1.89548V6.84H18.6602V16.875ZM1.89548 5.715V2.25H4.13077V4.5H7.48371V2.25H13.0719V4.5H16.4249V2.25H18.6602V5.715H1.89548Z"
        :class="colorClass"
      />
      <path
        d="M10.5461 11.8575L13.0161 14.3438L12.7591 14.6025L10.2891 12.1163L7.81907 14.6025L7.56201 14.3438L10.032 11.8575L7.56201 9.3713L7.81907 9.11255L10.2891 11.5988L12.7591 9.11255L13.0161 9.3713L10.5461 11.8575Z"
        :class="colorClass"
        stroke-width="0.51"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_8933">
        <rect width="19" height="18" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
